/**
 * Globalny konsument Redux (state.ui.notification) → snackbar.
 * Różnica od useNotifications: useNotifications to imperatywne API (showSuccessMessage itd.),
 * ten hook reaguje na dispatch(setNotification(...)) z dowolnego miejsca w aplikacji.
 * Wywołać tylko raz w drzewie (Routes.tsx), żeby uniknąć podwójnego wyświetlania.
 */
import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { reduxActions, useDispatch, useSelector } from 'store';

export const useNotificationToSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (!notification) {
      dispatch(reduxActions.setNotification(null));
      return;
    }
    enqueueSnackbar(notification.message, {
      variant: notification.variant,
      ...(notification.variant === 'error' ? { autoHideDuration: 6000 } : {})
    });
    dispatch(reduxActions.setNotification(null));
  }, [notification, dispatch, enqueueSnackbar]);
};
